import {memo, useEffect, useMemo} from "react";
import { useMap, } from "react-leaflet";
import { useSelector } from 'react-redux';
import mapStateToProps from "./mapStateToProps";

const MapControllerVievport = ({ geoedit, paletteWidth, isGeozonesIntersections }) => {
    const map = useMap()
    const {
        geoObjs: { data: geoArr = [] } = {},
        routeArr = [],
        routeSettingsArr = [],
        selectedGeoObjArray = [],
        geozoneArr = [],
        geozoneSettingsArr = [],
    } = useSelector(mapStateToProps);

    const vievport = useMemo(() => {
        const visibleGeozone = geozoneArr
            .filter(({ polygon }, i) => (geozoneSettingsArr?.[i]?.active && polygon?.length > 2))
            .map(({ polygon }) => polygon)
            .flat()
        const visibleRoutes = routeArr
            .filter((item, i) => routeSettingsArr?.[i]?.active)
            .flat()
        const activePoints = geoArr
            .filter(({ id }) => selectedGeoObjArray.includes(id))
        const opArr = [...activePoints.map(({ point: { x, y } = {} }) => ({ x, y })), ...visibleRoutes, ...visibleGeozone]
        if (opArr.length) {
            const xs = opArr.map(({ x }) => parseFloat(x))
            const ys = opArr.map(({ y }) => parseFloat(y))
            const minX = Math.min(...xs);
            const minY = Math.min(...ys);
            const maxX = Math.max(...xs);
            const maxY = Math.max(...ys);
            return { minX, minY, maxX, maxY }
        } else {
            return null;
        }
    }, [geoArr, selectedGeoObjArray, routeArr, routeSettingsArr, geozoneArr, geozoneSettingsArr])

    useEffect(() => {
        //заставляет карту начать грузится
        setTimeout(() => {
            map.invalidateSize()
        }, 10)
    }, [paletteWidth, isGeozonesIntersections])

    useEffect(() => {
        //масштабируем карту к вычисленному вьюпорту
        if (vievport && !geoedit) {
            const { minX, minY, maxX, maxY } = vievport

            map.fitBounds([[minX, minY], [maxX, maxY]])
        }
    }, [vievport, geoedit])

    return null
}

export default memo(MapControllerVievport)